module.exports = __webpack_public_path__ + "img/banner.be41a4d4.jpg";